/* Sprint 21 — shared color display used everywhere a vehicle color is shown.
   Never renders raw HEX codes to the user; instead pairs a colored dot
   (from the stored HEX) with the human-readable name. */

import { colorDisplayName, colorSwatchHex } from "@/lib/vehicleCatalog";
import { cn } from "@/lib/utils";

export function ColorChip({ value, size = "sm", className, showName = true, testId }) {
  const v = (value || "").trim();
  if (!v) return null;
  const name = colorDisplayName(v);
  const hex = colorSwatchHex(v);
  const dot = size === "lg" ? "h-3.5 w-3.5" : size === "md" ? "h-3 w-3" : "h-2.5 w-2.5";
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 align-middle", className)}
      data-testid={testId || "color-chip"}
      title={name}
    >
      <span
        className={cn("rounded-full ring-1 ring-black/10 dark:ring-white/15 shrink-0", dot)}
        style={{ background: hex || "transparent" }}
        aria-hidden
      />
      {showName && <span className="truncate">{name}</span>}
    </span>
  );
}
